<script>
import moment from 'moment'
import EditableListView from '@/components/common/EditableListView'
import { mapGetters, mapState } from 'vuex'
import { botApi } from '../../api'
import { profileApi } from '../../api'
import { workflowApi } from '../../api'
import { ruleApi } from '../../api'
import { selfServiceApi } from '../../api'
import { userApi as honeyUserApi } from '../../api'
import { formApi as honeyFormsApi } from '../../api'

export default {
  props: {
    selected: Object
  },

  data() {
    return {
      editName: false,
      editDescription: false,
      profileUpdating: false,
      profiledBotsUpdating: false,
      profiledWorkflowsUpdating: false,
      profiledHoneyUsersUpdating: false,
      profiledSelfServicesUpdating: false,
      name: this.selected.name,
      lastReplicated: this.selected.lastReplicatedLocal,
      description: this.selected.description,
      searchAttributes: ['name', 'description', 'username', 'hexId'],
      honeyFormsLoading: false,
      profiledHoneyFormsUpdating: false,
      rulesLoading: false,
      profiledRulesUpdating: false,
      bots: [],
      profiledBots: [],
      workflows: [],
      profiledWorkflows: [],
      rules: [],
      profiledRules: [],
      selfServices: [],
      profiledSelfServices: [],
      honeyUsers: [],
      profiledHoneyUsers: [],
      honeyForms: [],
      profiledHoneyForms: []
    }
  },

  computed: {
    ...mapState({
      // profiledBots: state => state.profiles.profiledBots,
      // honeyForms: state => state.honeyForms.honeyForms,
      profiledHoneyForms: state => state.profiles.profiledHoneyForms
      // profiledWorkflows: state => state.profiles.profiledWorkflows,
      // profiledRules: state => state.profiles.profiledRules,
      // profiledHoneyUsers: state => state.profiles.profiledHoneyUsers
      // profiledSelfServices: state => state.profiles.profiledSelfServices,
      // bots: state => state.bots.bots,
      // workflows: state => state.workflows.workflows,
      // rules: state => state.rules.rules,
      // selfServices: state => state.selfServices.selfServices,
      // honeyUsers: state => state.honeyUsers.honeyUsers
    }),
    ...mapGetters({
      can: 'can'
    })
  },

  watch: {
    selected() {
      this.getAssociations()
      this.name = this.selected.name
      this.description = this.selected.description
      this.lastReplicated = this.selected.lastReplicatedLocal
    }
  },

  created() {
    if (this.selected) {
      this.getAssociations()
    }
    // if (this.bots && this.bots.length === 0) {
    //   this.getBots()
    // }
    // if (this.workflows && this.workflows.length === 0) {
    //   this.getWorkflows()
    // }
    // if (this.rules && this.rules.length === 0) {
    //   this.getRules()
    // }
    // if (this.selfServices && this.selfServices.length === 0) {
    //   this.getSelfServices()
    // }
    // if (this.honeyUsers && this.honeyUsers.length === 0) {
    //   this.getHoneyUsers()
    // }
    // if (this.honeyForms && this.honeyForms.length === 0) {
    //   this.getHoneyForms()
    // }
  },

  methods: {
    getAssociations() {
      this.getProfiledBots()
      this.getProfiledWorkflows()
      this.getProfiledRules()
      this.getProfiledSelfServices()
      this.getProfiledHoneyUsers()
      this.getProfiledHoneyForms()
    },
    async getHoneyForms(_, url) {
      this.honeyFormsLoading = true
      try {
        // await this.$store.dispatch('fetchHoneyForms')
        const { data } = await honeyFormsApi.fetchForms(url)
        this.honeyForms = data._embedded.honeyForms
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Forms',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.honeyFormsLoading = false
    },
    async createCandidateGroup() {
      this.profileUpdating = true
      try {
        await this.$store.dispatch(
          'replicateCandidateGroup',
          this.selected.hexId
        )
        await this.$store.dispatch('directNotification', {
          message:
            'Candidate group replication request raised successfully, ' +
            "Please refresh and check the 'Last Replicated' time for confirmation",
          type: 'success',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Candidate group replication request Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.profileUpdating = false
    },

    async getProfiledHoneyForms() {
      this.profiledBotsUpdating = true
      try {
        // await this.$store.dispatch('fetchProfiledHoneyForms', this.selected)
        this.profiledHoneyForms = await profileApi.fetchProfiledHoneyForms(
          this.selected
        )
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch form(s) for Profile',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.profiledBotsUpdating = false
    },
    async getProfiledBots() {
      this.profiledBotsUpdating = true
      try {
        this.profiledBots = await profileApi.fetchProfiledBots(this.selected)
        // await this.$store.dispatch('fetchProfiledBots', this.selected)
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Bot(s) for Profile',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.profiledBotsUpdating = false
    },

    async getProfiledWorkflows() {
      this.profiledWorkflowsUpdating = true
      try {
        // await this.$store.dispatch('fetchProfiledWorkflows', this.selected)
        this.profiledWorkflows = await profileApi.fetchProfiledWorkflows(
          this.selected
        )
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Workflow(s) for Profile',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.profiledWorkflowsUpdating = false
    },

    async getProfiledRules() {
      this.profiledRulesUpdating = true
      try {
        // await this.$store.dispatch('fetchProfiledRules', this.selected)
        this.profiledRules = await profileApi.fetchProfiledRules(this.selected)
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Rules(s) for Profile',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.profiledRulesUpdating = false
    },

    async getProfiledHoneyUsers() {
      this.profiledHoneyUsersUpdating = true
      try {
        // await this.$store.dispatch('fetchProfiledHoneyUsers', this.selected)
        this.profiledHoneyUser = await profileApi.fetchProfiledHoneyUsers(
          this.selected
        )
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch User(s) for Profile',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.profiledHoneyUsersUpdating = false
    },

    async getProfiledSelfServices() {
      this.profiledSelfServicesUpdating = true
      try {
        // await this.$store.dispatch('fetchProfiledSelfServices', this.selected)
        this.profiledSelfServices = await profileApi.fetchProfiledSelfServices(
          this.selected
        )
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Self-Service(s) for Profile',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.profiledSelfServicesUpdating = false
    },

    async getBots(_, url) {
      this.profiledBotsUpdating = true
      try {
        // await this.$store.dispatch('fetchBots')
        const { data } = await botApi.fetchBots(url)
        this.bots = data._embedded.bots
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Bot(s)',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.profiledBotsUpdating = false
    },

    async getWorkflows(_, url) {
      this.profiledWorkflowsUpdating = true
      try {
        // await this.$store.dispatch('fetchWorkflows')
        const { data } = await workflowApi.fetchWorkflows(url)
        this.workflows = data._embedded.workflows
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Workflow(s)',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.profiledWorkflowsUpdating = false
    },

    async getRules(_, url) {
      this.profiledRulesUpdating = true
      try {
        // await this.$store.dispatch('fetchRules')
        const { data } = await ruleApi.fetchRules(url)
        this.rules = data._embedded.rules
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Rules(s)',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.profiledRulesUpdating = false
    },

    async getSelfServices(_, url) {
      this.profiledSelfServicesUpdating = true
      try {
        // await this.$store.dispatch('fetchSelfServices')
        const { data } = await selfServiceApi.fetchSelfService(url)
        this.selfServices = data._embedded.selfServices
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Self-Service(s)',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.profiledSelfServicesUpdating = false
    },

    async getHoneyUsers(_, url) {
      this.profiledHoneyUsersUpdating = true
      try {
        // await this.$store.dispatch('fetchHoneyUsers')
        const { data } = await honeyUserApi.fetchUser(url)
        this.honeyUsers = data._embedded.honeyUsers
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch User(s)',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.profiledHoneyUsersUpdating = false
    },

    async setName() {
      this.profileUpdating = true
      this.editName = false
      try {
        await this.$store.dispatch('updateProfile', {
          body: { name: this.name },
          hexId: this.selected.hexId
        })
        await this.$store.dispatch('directNotification', {
          message: 'Profile renamed Successfully',
          type: 'success',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Profile rename Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        this.resetName()
      }
      this.profileUpdating = false
    },

    resetName() {
      this.editName = false
      this.name = this.selected.name
    },

    async setDescription() {
      this.profileUpdating = true
      this.editDescription = false
      try {
        await this.$store.dispatch('updateProfile', {
          body: { description: this.description },
          hexId: this.selected.hexId
        })
        await this.$store.dispatch('directNotification', {
          message: 'Profile description updated Successfully',
          type: 'success',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Profile description update Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        this.resetDescription()
      }
      this.profileUpdating = false
    },

    resetDescription() {
      this.editDescription = false
      this.description = this.selected.description
    },

    async botsAdded(bots) {
      this.profiledBotsUpdating = true
      try {
        await Promise.all(
          bots.map(bot => {
            profileApi.addbotsToProfile(bot, this.selected.hexId)
          })
        )
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Bot added to Profile Successfully',
          description: 'Bot added to Profile Successfully',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to add Bot(s)',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      try {
        this.profiledBots = await profileApi.fetchProfiledBots(this.selected)
        // await this.$store.dispatch('fetchProfiledBots', this.selected)
      } catch (e) {
        console.log(e)
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Bot(s) for Profile',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.profiledBotsUpdating = false
    },

    async botsDeleted(bots) {
      this.profiledBotsUpdating = true
      try {
        // await this.$store.dispatch('deleteBotFromProfile', {
        //   bots,
        //   profile: this.selected
        // })

        await Promise.all(
          bots.map(bot => {
            profileApi.deleteBotFromProfile(bot, this.selected)
          })
        )

        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Bot(s) deleted for Profile Successfully',
          description: 'Bot(s) deleted for Profile Successfully',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to delete Bot(s)',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      try {
        // await this.$store.dispatch('fetchProfiledBots', this.selected)
        this.profiledBots = await profileApi.fetchProfiledBots(this.selected)
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Bot(s) for Profile',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.profiledBotsUpdating = false
    },

    async honeyFormsAdded(honeyForms) {
      this.profiledHoneyFormsUpdating = true
      try {
        // await this.$store.dispatch('addHoneyFormToProfile', {
        //   honeyForms,
        //   profile: this.selected
        // })

        await Promise.all(
          honeyForms.map(form => {
            profileApi.addHoneyFormToProfile(form, this.selected)
          })
        )
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Forms added to Profile Successfully',
          description: 'Forms added to Profile Successfully',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to add Form(s)',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      try {
        // await this.$store.dispatch('fetchProfiledHoneyForms', this.selected)
        this.profiledHoneyForms = await profileApi.fetchProfiledHoneyForms(
          this.selected
        )
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Form(s) for Profile',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.profiledHoneyFormsUpdating = false
    },

    async honeyFormsDeleted(honeyForms) {
      this.profiledHoneyFormsUpdating = true
      try {
        // await this.$store.dispatch('deleteHoneyFormFromProfile', {
        //   honeyForms,
        //   profile: this.selected
        // })
        await Promise.all(
          honeyForms.map(form =>
            profileApi.deleteHoneyFormFromProfile(form, this.selected)
          )
        )
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Form(s) deleted for Profile Successfully',
          description: 'Form(s) deleted for Profile Successfully',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to delete Form(s)',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      try {
        // await this.$store.dispatch('fetchProfiledHoneyForms', this.selected)
        this.profiledHoneyForms = await profileApi.fetchProfiledHoneyForms(
          this.selected
        )
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Form(s) for Profile',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.profiledHoneyFormsUpdating = false
    },

    async workflowsAdded(workflows) {
      this.profiledWorkflowsUpdating = true
      try {
        // await this.$store.dispatch('addWorkflowToProfile', {
        //   workflows,
        //   profile: this.selected
        // })
        await Promise.all(
          workflows.map(workflow =>
            profileApi.addWorkflowToProfile(workflow, this.selected)
          )
        )
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Workflow(s) added to Profile Successfully',
          description: 'Workflow(s) added to Profile Successfully',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to add Workflow(s)',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      try {
        // await this.$store.dispatch('fetchProfiledWorkflows', this.selected)
        this.profiledWorkflows = await profileApi.fetchProfiledWorkflows(
          this.selected
        )
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Workflow(s) for Profile',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.profiledWorkflowsUpdating = false
    },

    async workflowsDeleted(workflows) {
      this.profiledWorkflowsUpdating = true
      try {
        // await this.$store.dispatch('deleteWorkflowFromProfile', {
        //   workflows,
        //   profile: this.selected
        // })

        await Promise.all(
          workflows.map(workflow =>
            profileApi.deleteWorkflowFromProfile(workflow, this.selected)
          )
        )
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Workflow(s) deleted for Profile Successfully',
          description: 'Workflow(s) deleted for Profile Successfully',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to delete Workflow(s)',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      try {
        // await this.$store.dispatch('fetchProfiledWorkflows', this.selected)
        this.profiledWorkflows = await profileApi.fetchProfiledWorkflows(
          this.selected
        )
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Workflow(s) for Profile',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.profiledWorkflowsUpdating = false
    },

    async rulesAdded(rules) {
      this.profiledRulesUpdating = true
      try {
        // await this.$store.dispatch('addRuleToProfile', {
        //   rules,
        //   profile: this.selected
        // })
        await Promise.all(
          rules.map(rule => {
            profileApi.addRuleToProfile(rule, this.selected)
          })
        )
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Rule(s) added to Profile Successfully',
          description: 'Rule(s) added to Profile Successfully',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to add Rule(s)',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      try {
        // await this.$store.dispatch('fetchProfiledRules', this.selected)
        this.profiledRules = await profileApi.fetchProfiledRules(this.selected)
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Rule(s) for Profile',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.profiledRulesUpdating = false
    },

    async rulesDeleted(rules) {
      this.profiledRulesUpdating = true
      try {
        // await this.$store.dispatch('deleteRuleFromProfile', {
        //   rules,
        //   profile: this.selected
        // })
        await Promise.all(
          rules.map(rule => {
            profileApi.deleteRuleFromProfile(rule, this.selected)
          })
        )
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Rule(s) deleted for Profile Successfully',
          description: 'Rule(s) deleted for Profile Successfully',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to delete Rule(s)',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      try {
        // await this.$store.dispatch('fetchProfiledRules', this.selected)
        this.profiledRules = await profileApi.fetchProfiledRules(this.selected)
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Rule(s) for Profile',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.profiledRulesUpdating = false
    },

    async honeyUsersAdded(honeyUsers) {
      this.profiledHoneyUsersUpdating = true
      try {
        // await this.$store.dispatch('addHoneyUserToProfile', {
        //   honeyUsers,
        //   profile: this.selected
        // })
        await Promise.all(
          honeyUsers.map(honeyUser =>
            profileApi.addHoneyUserToProfile(honeyUser, this.selected)
          )
        )
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'User(s) added to Profile Successfully',
          description: 'User(s) added to Profile Successfully',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to add User(s)',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      try {
        // await this.$store.dispatch('fetchProfiledHoneyUsers', this.selected)
        this.profiledHoneyUser = await profileApi.fetchProfiledHoneyUsers(
          this.selected
        )
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to Honey User(s) for Profile',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.profiledHoneyUsersUpdating = false
    },

    async honeyUsersDeleted(honeyUsers) {
      this.profiledHoneyUsersUpdating = true
      try {
        // await this.$store.dispatch('deleteHoneyUserFromProfile', {
        //   honeyUsers,
        //   profile: this.selected
        // })

        await Promise.all(
          honeyUsers.map(honeyUser =>
            profileApi.deleteHoneyUserFromProfile(honeyUser, this.selected)
          )
        )
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'User(s) deleted for Profile Successfully',
          description: 'User(s) deleted for Profile Successfully',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to delete User(s)',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      try {
        // await this.$store.dispatch('fetchProfiledHoneyUsers', this.selected)
        this.profiledHoneyUser = await profileApi.fetchProfiledHoneyUsers(
          this.selected
        )
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch User(s) for Profile',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.profiledHoneyUsersUpdating = false
    },

    async selfServicesAdded(selfServices) {
      this.profiledSelfServicesUpdating = true
      try {
        // await this.$store.dispatch('addSelfServiceToProfile', {
        //   selfServices,
        //   profile: this.selected
        // })
        await Promise.all(
          selfServices.map(selfService =>
            profileApi.addSelfServiceToProfile(selfService, this.selected)
          )
        )
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Self-Service(s) deleted for Profile Successfully',
          description: 'Self-Service(s) deleted for Profile Successfully',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to delete Self-Service(s)',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      try {
        // await this.$store.dispatch('fetchProfiledSelfServices', this.selected)
        this.profiledSelfServices = await profileApi.fetchProfiledSelfServices(
          this.selected
        )
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Self-Service(s) for Profile',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.profiledSelfServicesUpdating = false
    },

    async selfServicesDeleted(selfServices) {
      this.profiledSelfServicesUpdating = true
      try {
        // await this.$store.dispatch('deleteSelfServiceFromProfile', {
        //   selfServices,
        //   profile: this.selected
        // })
        await Promise.all(
          selfServices.map(selfService =>
            profileApi.deleteSelfServiceFromProfile(selfService, this.selected)
          )
        )
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Self-Service(s) deleted for Profile Successfully',
          description: 'Self-Service(s) deleted for Profile Successfully',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to delete Self-Service(s)',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      try {
        // await this.$store.dispatch('fetchProfiledSelfServices', this.selected)
        this.profiledSelfServices = await profileApi.fetchProfiledSelfServices(
          this.selected
        )
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Self-Service(s) for Profile',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.profiledSelfServicesUpdating = false
    },

    async search(query, category) {
      const url = `?search=${query}&page=1&size=20`

      switch (category) {
        case 'bots': {
          this.getBots('', url)
          break
        }
        case 'workflows': {
          this.getWorkflows('', url)
          break
        }
        case 'rules': {
          this.getRules('', url)
          break
        }
        case 'selfServices': {
          this.getSelfServices('', url)
          break
        }
        case 'honeyUsers': {
          this.getHoneyUsers('', url)
          break
        }
        case 'honeyForms': {
          this.getHoneyForms('', url)
          break
        }
      }
    }
  },

  components: {
    EditableListView
  }
}
</script>
<template>
  <v-card class="beez-card">
    <v-toolbar card class="elevation-2" dense>
      <v-toolbar-title class="body-2 beez-bold "
        >{{ selected.name }}
      </v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click.stop="createCandidateGroup">
          <v-icon>
            sync_alt
          </v-icon>
        </v-btn>
        <span>Replicate Candidate Group</span>
      </v-tooltip>
    </v-toolbar>
    <v-progress-linear
      :active="profileUpdating"
      class="ma-0"
      color="accent"
      height="5"
      indeterminate
    />
    <div class="pa-3">
      <v-text-field
        v-model="name"
        :outline="$vuetify.dark"
        :readonly="!editName"
        color="secondary"
        label="Name"
      >
        <template slot="append">
          <template v-if="editName">
            <v-icon @click="resetName">clear</v-icon>
            <v-icon @click="setName">save</v-icon>
          </template>
          <template v-else>
            <v-icon v-if="can('PROFILE_NAME_EDIT')" @click="editName = true"
              >edit
            </v-icon>
          </template>
        </template>
      </v-text-field>

      <v-textarea
        v-model="description"
        :outline="$vuetify.dark"
        :readonly="!editDescription"
        :rows="1"
        auto-grow
        color="secondary"
        label="Description"
      >
        <template slot="append">
          <template v-if="editDescription">
            <v-icon @click="resetDescription">clear</v-icon>
            <v-icon @click="setDescription">save</v-icon>
          </template>
          <template v-else>
            <v-icon
              v-if="can('PROFILE_DES_EDIT')"
              @click="editDescription = true"
              >edit
            </v-icon>
          </template>
        </template>
      </v-textarea>

      <v-text-field
        v-model="lastReplicated"
        :outline="$vuetify.dark"
        readonly
        color="secondary"
        label="Last Replicated"
      >
      </v-text-field>

      <div v-if="can('PROFILE_BOT')" class="py-4">
        <editable-list-view
          :key="'pro-' + selected.hexId"
          :allItems="bots"
          :search-attributes="searchAttributes"
          :selectedItems="profiledBots"
          :updating="profiledBotsUpdating"
          title="Bots"
          @added="botsAdded"
          @deleted="botsDeleted"
          @queryChanged="query => search(query, 'bots')"
        >
          <template slot="empty-list-placeholder-selected">
            Please click the edit icon to start adding Bots.
          </template>

          <template
            v-for="(slotName, i) in [
              'list-item-selected',
              'list-item-add',
              'list-item-delete'
            ]"
            :slot="slotName"
            slot-scope="slotProps"
          >
            <v-hover :key="'item4_' + i">
              <v-list-tile-content slot-scope="{ hover }">
                <v-container fulid>
                  <v-layout row>
                    <v-flex shrink>
                      <v-avatar size="40">
                        <img alt="link" src="/images/Bot.svg" />
                      </v-avatar>
                    </v-flex>
                    <v-flex grow pl-3>
                      <v-list-tile-title>
                        {{ slotProps.item.name }}
                      </v-list-tile-title>
                      <v-list-tile-sub-title
                        >{{ slotProps.item.description }}
                      </v-list-tile-sub-title>
                    </v-flex>
                    <v-flex shrink>
                      <v-tooltip bottom>
                        <v-btn
                          v-if="hover"
                          slot="activator"
                          :to="{
                            name: 'bot-detail',
                            params: { hexId: slotProps.item.hexId }
                          }"
                          flat
                          icon
                          small
                        >
                          <v-icon>link</v-icon>
                        </v-btn>
                        <span>Quick Link</span>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-list-tile-content>
            </v-hover>
          </template>
        </editable-list-view>
      </div>
      <div v-if="can('PROFILE_WORKFLOW')" class="pb-4">
        <editable-list-view
          :key="'pro-' + selected.hexId"
          :allItems="workflows"
          :search-attributes="searchAttributes"
          :selectedItems="profiledWorkflows"
          :updating="profiledWorkflowsUpdating"
          title="Workflows"
          @added="workflowsAdded"
          @deleted="workflowsDeleted"
          @queryChanged="query => search(query, 'workflows')"
        >
          <template slot="empty-list-placeholder-selected">
            Please click the edit icon to start adding Workflows.
          </template>

          <template
            v-for="(slotName, i) in [
              'list-item-selected',
              'list-item-add',
              'list-item-delete'
            ]"
            :slot="slotName"
            slot-scope="slotProps"
          >
            <v-hover :key="'item3_' + i">
              <v-list-tile-content slot-scope="{ hover }">
                <v-container fulid>
                  <v-layout row>
                    <v-flex shrink>
                      <v-avatar size="40">
                        <img alt="link" src="/images/Workflow.svg" />
                      </v-avatar>
                    </v-flex>
                    <v-flex grow pl-3>
                      <v-list-tile-title
                        >{{ slotProps.item.name }}
                      </v-list-tile-title>
                      <v-list-tile-sub-title
                        >{{ slotProps.item.description }}
                      </v-list-tile-sub-title>
                    </v-flex>
                    <v-flex shrink>
                      <v-tooltip bottom>
                        <v-btn
                          v-if="hover"
                          slot="activator"
                          :to="{
                            name: 'workflow-detail',
                            params: { hexId: slotProps.item.hexId }
                          }"
                          flat
                          icon
                          small
                        >
                          <v-icon>link</v-icon>
                        </v-btn>
                        <span>Quick Link</span>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-list-tile-content>
            </v-hover>
          </template>
        </editable-list-view>
      </div>
      <div v-if="can('PROFILE_RULE')" class="pb-4">
        <editable-list-view
          :key="'pro-' + selected.hexId"
          :allItems="rules"
          :search-attributes="searchAttributes"
          :selectedItems="profiledRules"
          :updating="profiledRulesUpdating"
          title="Rules"
          @added="rulesAdded"
          @deleted="rulesDeleted"
          @queryChanged="query => search(query, 'rules')"
        >
          <template slot="empty-list-placeholder-selected">
            Please click the edit icon to start adding Rules.
          </template>

          <template
            v-for="(slotName, i) in [
              'list-item-selected',
              'list-item-add',
              'list-item-delete'
            ]"
            :slot="slotName"
            slot-scope="slotProps"
          >
            <v-hover :key="'item3_' + i">
              <v-list-tile-content slot-scope="{ hover }">
                <v-container fulid>
                  <v-layout row>
                    <v-flex shrink>
                      <v-avatar size="40">
                        <img alt="link" src="/images/Workflow.svg" />
                      </v-avatar>
                    </v-flex>
                    <v-flex grow pl-3>
                      <v-list-tile-title
                        >{{ slotProps.item.name }}
                      </v-list-tile-title>
                      <v-list-tile-sub-title
                        >{{ slotProps.item.description }}
                      </v-list-tile-sub-title>
                    </v-flex>
                    <v-flex shrink>
                      <v-tooltip bottom>
                        <v-btn
                          v-if="hover"
                          slot="activator"
                          :to="{
                            name: 'rule-detail',
                            params: { hexId: slotProps.item.hexId }
                          }"
                          flat
                          icon
                          small
                        >
                          <v-icon>link</v-icon>
                        </v-btn>
                        <span>Quick Link</span>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-list-tile-content>
            </v-hover>
          </template>
        </editable-list-view>
      </div>
      <div v-if="can('PROFILE_SERVICE')" class="pb-4">
        <editable-list-view
          :key="'pro-' + selected.hexId"
          :allItems="selfServices"
          :search-attributes="searchAttributes"
          :selectedItems="profiledSelfServices"
          :updating="profiledSelfServicesUpdating"
          title="Self Services"
          @added="selfServicesAdded"
          @deleted="selfServicesDeleted"
          @queryChanged="query => search(query, 'selfServices')"
        >
          <template slot="empty-list-placeholder-selected">
            Please click the edit icon to start adding Self Services.
          </template>

          <template
            v-for="(slotName, i) in [
              'list-item-selected',
              'list-item-add',
              'list-item-delete'
            ]"
            :slot="slotName"
            slot-scope="slotProps"
          >
            <v-hover :key="'item2_' + i">
              <v-list-tile-content slot-scope="{ hover }">
                <v-container fulid>
                  <v-layout row>
                    <v-flex shrink>
                      <v-avatar size="40">
                        <!-- Todo:Need to change Icon for self service -->
                        <img alt="link" src="/images/Nectar.svg" />
                      </v-avatar>
                    </v-flex>
                    <v-flex grow pl-3>
                      <v-list-tile-title
                        >{{ slotProps.item.name }}
                      </v-list-tile-title>
                      <v-list-tile-sub-title
                        >{{ slotProps.item.description }}
                      </v-list-tile-sub-title>
                    </v-flex>
                    <v-flex shrink>
                      <v-tooltip bottom>
                        <v-btn
                          v-if="hover"
                          slot="activator"
                          :to="{
                            name: 'self-service-detail',
                            params: { hexId: slotProps.item.hexId }
                          }"
                          flat
                          icon
                          small
                        >
                          <v-icon>link</v-icon>
                        </v-btn>
                        <span>Quick Link</span>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-list-tile-content>
            </v-hover>
          </template>
        </editable-list-view>
      </div>
      <div v-if="can('PROFILE_USER')" class="pb-4">
        <editable-list-view
          :key="'pro-' + selected.hexId"
          :allItems="honeyUsers"
          :multiple="false"
          :search-attributes="searchAttributes"
          :selectedItems="profiledHoneyUser"
          :updating="profiledHoneyUsersUpdating"
          title="Honey Users"
          @added="honeyUsersAdded"
          @deleted="honeyUsersDeleted"
          @queryChanged="query => search(query, 'honeyUsers')"
        >
          <template slot="empty-list-placeholder-selected">
            Please click the edit icon to start adding Honey Users.
          </template>

          <template
            v-for="(slotName, i) in [
              'list-item-selected',
              'list-item-add',
              'list-item-delete'
            ]"
            :slot="slotName"
            slot-scope="slotProps"
          >
            <v-hover :key="'item_' + i">
              <v-list-tile-content slot-scope="{ hover }">
                <v-container fulid>
                  <v-layout row>
                    <v-flex shrink>
                      <v-list-tile-avatar :key="i + 'avatar'">
                        <vue-letter-avatar
                          :name="slotProps.item.username"
                          :rounded="true"
                          size="40"
                        />
                      </v-list-tile-avatar>
                    </v-flex>
                    <v-flex grow pl-1>
                      <v-list-tile-title
                        >{{ slotProps.item.username }}
                      </v-list-tile-title>
                    </v-flex>
                    <v-flex shrink>
                      <v-tooltip bottom>
                        <v-btn
                          v-if="hover"
                          slot="activator"
                          :to="{
                            name: 'user-detail',
                            params: { hexId: slotProps.item.hexId }
                          }"
                          flat
                          icon
                          small
                        >
                          <v-icon>link</v-icon>
                        </v-btn>
                        <span>Quick Link</span>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-list-tile-content>
            </v-hover>
          </template>
        </editable-list-view>
      </div>
      <div v-if="can('PROFILE_FORM')" class="pb-4">
        <editable-list-view
          :key="'pro-' + selected.hexId"
          :allItems="honeyForms"
          :search-attributes="searchAttributes"
          :selectedItems="profiledHoneyForms"
          :updating="profiledHoneyFormsUpdating"
          title="Forms"
          @added="honeyFormsAdded"
          @deleted="honeyFormsDeleted"
          @queryChanged="query => search(query, 'honeyForms')"
        >
          <template slot="empty-list-placeholder-selected">
            Please click the edit icon to start adding Forms.
          </template>

          <template
            v-for="(slotName, i) in [
              'list-item-selected',
              'list-item-add',
              'list-item-delete'
            ]"
            :slot="slotName"
            slot-scope="slotProps"
          >
            <v-hover :key="'item_' + i">
              <v-list-tile-content slot-scope="{ hover }">
                <v-container fulid>
                  <v-layout row>
                    <v-flex shrink>
                      <v-avatar size="40">
                        <img alt="link" src="/images/Bot.svg" />
                      </v-avatar>
                    </v-flex>
                    <v-flex grow pl-1>
                      <v-list-tile-title
                        >{{ slotProps.item.formKey }}
                      </v-list-tile-title>
                      <v-list-tile-sub-title
                        >{{ slotProps.item.description }}
                      </v-list-tile-sub-title>
                    </v-flex>
                    <v-flex shrink>
                      <v-tooltip bottom>
                        <v-btn
                          v-if="hover"
                          slot="activator"
                          :to="{
                            name: 'honey-form-detail',
                            params: { hexId: slotProps.item.hexId }
                          }"
                          flat
                          icon
                          small
                        >
                          <v-icon>link</v-icon>
                        </v-btn>
                        <span>Quick Link</span>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-list-tile-content>
            </v-hover>
          </template>
        </editable-list-view>
      </div>
    </div>
  </v-card>
</template>
